import axiosInstance from '../../lib/axios';

export const fetchFrameworkRegistry = async () => {
  const response = await axiosInstance.get('/notifications/framework/registry/');
  return response.data;
};

export const fetchFrameworkEvents = async (params = {}) => {
  const response = await axiosInstance.get('/notifications/framework/events/', { params });
  return response.data;
};

export const fetchFrameworkSummary = async (days) => {
  const response = await axiosInstance.get('/notifications/framework/summary/', {
    params: { days },
  });
  return response.data;
};
